/*
 * @Description: 项目管理接口集
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2025-03-06 17:57:08
 * @LastEditors: Monkey
 * @LastEditTime: 2026-03-19 10:31:47
 */
import config from '@/config';
import http from '@/utils/request';

export default {
  info: {
    page: {
      url: `${config.API_URL}/project/page`,
      name: '获取项目信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    list: {
      url: `${config.API_URL}/project/list`,
      name: '获取项目信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    find: {
      url: `${config.API_URL}/project/findById`,
      name: '查询项目公司',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/project/save`,
      name: '保存项目信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
  },
  flow: {
    page: {
      url: `${config.API_URL}/project/flow/page`,
      name: '获取项目流程信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    find: {
      url: `${config.API_URL}/project/flow/findById`,
      name: '查询项目流程信息',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/project/flow/save`,
      name: '保存项目流程信息',
      post: async function (params) {
        return await http.post(this.url, params);
      }
    },
    update: {
      url: `${config.API_URL}/project/flow/update`,
      name: '更新项目流程信息',
      post: async function (params) {
        return await http.post(this.url, params);
      }
    },
    remove: {
      url: `${config.API_URL}/project/flow/remove`,
      name: '删除项目流程信息',
      get: async function (params) {
        return await http.get(this.url, params);
      }
    },
  },
  follow: {
    save: {
      url: `${config.API_URL}/project/follow/save`,
      name: '添加公司跟进',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    list: {
      url: `${config.API_URL}/project/follow/list`,
      name: '获取公司跟进列表',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    }
  },
  talent: {
    list: {
      url: `${config.API_URL}/customer/talent/real/project/page/byTalent`,
      name: '获取某个项目的人才信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    listByCompanyId: {
      url: `${config.API_URL}/customer/talent/real/project/page/byCompany`,
      name: '获取某个公司的人才信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    count: {
      url: `${config.API_URL}/customer/talent/real/project/count`,
      name: '获取人才项目数量',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    companyCount: {
      url: `${config.API_URL}/customer/talent/real/project/company/count`,
      name: '获取公司人才数量',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    countByStatus: {
      url: `${config.API_URL}/customer/talent/real/project/count/byStatus`,
      name: '获取人才项目状态数量',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    findProcess: {
      url: `${config.API_URL}/customer/talent/real/project/process`,
      name: '获取项目流程信息',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/customer/talent/real/project/save`,
      name: '保存项目人才信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    saveAndBindForList: {
      url: `${config.API_URL}/customer/talent/real/project/saveAndBindForList`,
      name: '保存多个项目人才信息并绑定',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    next: {
      url: `${config.API_URL}/customer/talent/real/project/next`,
      name: '项目状态流转',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    remove: {
      url: `${config.API_URL}/customer/talent/real/project/remove`,
      name: '移出项目',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    reject: {
      url: `${config.API_URL}/customer/talent/real/project/reject`,
      name: '拒绝项目',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    transfer: {
      url: `${config.API_URL}/customer/talent/real/project/transfer`,
      name: '项目转让',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },

    interview: {
      name: '邀约面试',
      findInterview: {
        url: `${config.API_URL}/customer/talent/interview/project/interview/find`,
        name: '获取项目面试信息',
        get: async function (params) {
          return await http.get(this.url, params);
        },
      },
      save: {
        url: `${config.API_URL}/customer/talent/interview/project/interview/save`,
        name: '保存项目面试信息',
        post: async function (params) {
          return await http.post(this.url, params);
        },
      },
      next: {
        url: `${config.API_URL}/customer/talent/real/project/interview`,
        name: '面试到场',
        post: async function (params) {
          return await http.post(this.url, params);
        },
      },
    },
    pendingEntry: {
      name: '待入职，到下个状态',
      find: {
        url: `${config.API_URL}/customer/talent/entry/find`,
        name: '获取项目人才入职信息',
        get: async function (params) {
          return await http.get(this.url, params);
        },
      },
      next: {
        url: `${config.API_URL}/customer/talent/real/project/pendingEntry`,
        name: '入职后，到稳岗状态',
        post: async function (params) {
          return await http.post(this.url, params);
        },
      }
    },
  },

  rule: {
    achieve: {
      save: {
        url: `${config.API_URL}/project/rule/achieve/save`,
        name: '保存项目业绩信息',
        post: async function (params) {
          return await http.post(this.url, params);
        },
      },
      findByProjectId: {
        url: `${config.API_URL}/project/rule/achieve/findByProjectId`,
        name: '查询项目业绩信息',
        get: async function (params) {
          return await http.get(this.url, params);
        },
      },
    }
  },

  salary: {
    findByProjectId: {
      url: `${config.API_URL}/project/salary/findByProjectId`,
      name: '查询项目薪资信息',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/project/salary/save`,
      name: '保存项目薪资信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    }
  },

  salarySettlement: {
    name: '薪资结算',
    info: {
      page: {
        url: `${config.API_URL}/project/salary/settlement/page`,
        name: '获取薪资结算信息',
        get: async function (params, config) {
          config = Object.assign({ codeFlag: true }, config)
          return await http.post(this.url, params, config);
        },
      }
    },
    detail: {
      page: {
        url: `${config.API_URL}/project/salary/settlement/detail/page`,
        name: '获取薪资结算详情',
        get: async function (params, config) {
          config = Object.assign({ codeFlag: true }, config)
          return await http.post(this.url, params, config);
        },
      },
      export: {
        url: `${config.API_URL}/project/salary/settlement/detail/export`,
        name: '导出薪资结算',
        get: async function (params, config) {
          config = Object.assign({ codeFlag: true }, config)
          return await http.get(this.url, params, config);
        },
      }
    },
    cycle: {
      page: {
        url: `${config.API_URL}/project/salary/settlement/cycle/page`,
        name: '获取薪资结算周期',
        get: async function (params, config) {
          config = Object.assign({ codeFlag: true }, config)
          return await http.post(this.url, params, config);
        },
      }
    }
  },

  attendance: {
    page: {
      url: `${config.API_URL}/project/raw/attendance/employee/page`,
      name: '获取项目考勤信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    upload: {
      url: `${config.API_URL}/project/raw/attendance/upload`,
      name: '上传项目考勤信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/project/raw/attendance/save`,
      name: '保存项目考勤信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
  },

  log: {
    url: `${config.API_URL}/project/logs/page`,
    name: '获取项目日志信息',
    get: async function (params, config) {
      config = Object.assign({ codeFlag: true }, config)
      return await http.post(this.url, params, config);
    },
  }
}
